var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomefill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.85742 11.3271C1.85742 11.5996 2.07715 11.8545 2.4375 11.8545C2.62207 11.8545 2.77148 11.7578 2.90332 11.6436L11.6572 4.30469C11.877 4.11133 12.1143 4.09375 12.3516 4.30469L21.0879 11.6436C21.2285 11.7578 21.3691 11.8545 21.5537 11.8545C21.8789 11.8545 22.1338 11.6611 22.1338 11.3447C22.1338 11.1338 22.0635 11.002 21.9053 10.8701L19.6289 8.9541V5.37695C19.6289 5.06055 19.418 4.8584 19.1104 4.8584H18.2842C17.9678 4.8584 17.748 5.06055 17.748 5.37695V7.37207L12.958 3.33789C12.3691 2.83691 11.6572 2.83691 11.0596 3.33789L2.08594 10.8701C1.92773 11.002 1.85742 11.1602 1.85742 11.3271ZM4.37988 19.3076C4.37988 20.4238 5.04785 21.083 6.18164 21.083H17.8271C18.9609 21.083 19.6289 20.4238 19.6289 19.3076V11.7754L12.5449 5.83398C12.1846 5.53516 11.7979 5.54395 11.4551 5.83398L4.37988 11.7666V19.3076ZM14.2236 20.002H9.75879V14.0693C9.75879 13.7002 10.0049 13.4629 10.3652 13.4629H13.6172C13.9863 13.4629 14.2236 13.7002 14.2236 14.0693V20.002Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomefill);
export default __webpack_public_path__ + "static/media/Home fill.51943e0990cf6012fe40bfa511d1fb2b.svg";
export { ForwardRef as ReactComponent };